<template>
  <el-dialog
    :title="$t('printerMachine.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div style="text-align: center;">
      <p>{{ $t('printerMachine.confirmDeletePrinter') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('printerMachine.cancel') }}</el-button>
      <el-button type="primary" @click="deletePrinterMachine">{{ $t('printerMachine.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShopPrinterMachine } from '@/api/shop/printerMachineApi'

export default {
  name: 'DeletePrinterMachine',
  data() {
    return {
      dialogVisible: false,
      deletePrinterMachineInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deletePrinterMachineInfo = Object.assign({}, params)
      this.dialogVisible = true
    },
    async deletePrinterMachine() {
      try {
        await deleteShopPrinterMachine(this.deletePrinterMachineInfo)
        this.$message.success(this.$t('printerMachine.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>